import BraveAndBoundless from '../../assets/images/whySubhead/brave_and_boundless.png'
import MarketingTransformation from '../../assets/images/whySubhead/marketing_transformation.png'

export const WhySubheadData = [
  {
    img: MarketingTransformation,
    title: 'Our Marketing Transformation Story',
    description: 'Our next chapter is written with great people, brands, and partners.',
    link: 'https://groups.coca-cola.com/teams/marketing/SitePages/The-Future-of-Marketing-Is-Now.aspx',
    event_type: 'pg_act_ourwork_fom_first_viewarticle',
  },
  {
    img: BraveAndBoundless,
    title: 'Brave and Boundless',
    description: 'Put your brave thinking cap on to create boundless consumer experiences.',
    link: 'https://groups.coca-cola.com/teams/marketing/SitePages/Engagement-Model/Brave-and-Boundless-Engagement-Model-Hub.aspx',
    event_type: 'pg_act_ourwork_fom_second_viewarticle',
  },
]
